import React from 'react';
import { Breadcrumbs, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

function PortalBreadcrumbs({ breadcrumbs }) {
    return (
        <Breadcrumbs sx={{ mb: 2 }}>
            {breadcrumbs.map((crumb, index) => (
                <Typography
                    key={crumb.path}
                    component={index === breadcrumbs.length - 1 ? 'span' : Link}
                    to={index === breadcrumbs.length - 1 ? undefined : crumb.path}
                    sx={{
                        textDecoration: index === breadcrumbs.length - 1 ? 'none' : 'underline',
                        color: index === breadcrumbs.length - 1 ? 'text.primary' : 'primary.main',
                        cursor: index === breadcrumbs.length - 1 ? 'default' : 'pointer'
                    }}
                >
                    {crumb.label}
                </Typography>
            ))}
        </Breadcrumbs>
    );
}

export default PortalBreadcrumbs;
